module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "hero": ""
    }
  }, [_c('div', {
    staticClass: "blur"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', [_vm._v("Play, Explore, Discover!")]), _vm._v(" "), _c('button', {
    staticClass: "primary btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gogogo()
      }
    }
  }, [_c('span', {
    staticClass: "thin"
  }, [_vm._v("Schedule")]), _vm._v(" Class Trip")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d48910b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tags/MainHero.vue
// module id = 380
// module chunks = 0